// ---------------------------------------------------------------------------
// Service & maintenance pricing.
// Source: Rango E-Cycles service rate card (Patna).
// All amounts in INR, labour only unless stated. Update here — the /service
// page and the home page both read from this file.
// ---------------------------------------------------------------------------

export const FIRST_SERVICE = {
  name: "1st Service",
  includes: "Brake tuning, gear tuning, minor wheel tuning",
  price: "Free of charge",
};

export const SERVICE_PLANS = [
  {
    id: "basic",
    name: "Basic Service",
    tagline: "Routine health check and tune-up",
    mechanicalHeading: "Mechanical inspection",
    mechanical: [
      "Perform complete cleaning of the e-cycle",
      "Inspect and tune gears, check chain wear",
      "Adjust brakes and inspect brake pads for wear",
      "Basic wheel tuning",
      "Lubricate gear and brake cables",
      "Check bottom bracket, headset and hub bearings for play",
      "Inspect wheel hubs for play",
      "Ensure all nuts and bolts are securely tightened",
      "Inspect tyres and inflate to recommended pressure",
    ],
    electricalHeading: "Electrical & electronic inspection",
    electrical: [
      "Verify battery functionality, power switch, state-of-charge (SoC) indicator and charging operation",
      "Test display functions and confirm all parameters are accurate",
      "Check throttle responsiveness and operation",
      "Confirm proper operation of lights, horn and indicators",
      "Test pedal-assist system for correct functionality",
      "Ensure motor cut-off is engaged when brakes are applied",
    ],
    prices: [
      { label: "Single speed e-cycle", amount: 699 },
      { label: "Geared e-cycle", amount: 899 },
    ],
    generalService: {
      label: "General service — normal cycle, any brand",
      amount: 250,
    },
  },
  {
    id: "full",
    name: "Full Service",
    tagline: "Complete strip-down, service and rebuild",
    mechanicalHeading: "Mechanical service",
    mechanical: [
      "Complete e-cycle cleaning and degreasing",
      "Gear tuning and indexing",
      "Brake tuning and brake pad wear inspection",
      "Wheel truing",
      "Gear and brake cable lubrication",
      "Motor servicing",
      "Bottom bracket servicing",
      "Headset servicing (replaced if necessary)",
      "Hub bearing servicing (cones / balls replaced if necessary)",
      "Ensure all nuts and bolts are securely tightened",
      "Inspect tyres and inflate to recommended pressure",
    ],
    electricalHeading: "Electrical & electronic inspection",
    electrical: [
      "Battery full-charge voltage reading",
      "Verify battery functionality, power switch, state-of-charge (SoC) indicator and charging operation",
      "Test display functions and confirm all parameters are accurate",
      "Check throttle responsiveness and operation",
      "Confirm proper operation of lights, horn and indicators",
      "Test pedal-assist system for correct functionality",
      "Ensure motor cut-off is engaged when brakes are applied",
    ],
    prices: [
      { label: "Single speed e-cycle", amount: 899 },
      { label: "Geared e-cycle", amount: 1199 },
    ],
    generalService: {
      label: "General service — normal cycle, any brand",
      amount: 350,
    },
  },
];

export const MOTOR_SERVICING = {
  name: "Motor servicing",
  description:
    "Overhauling of the motor, to be carried out every 2,000 km or 6 months, whichever comes first.",
  amount: 699,
};

export const COMPONENT_LABOUR = [
  { item: "Puncture repair", amount: 50 },
  { item: "New bottom bracket installation", amount: 99 },
  { item: "Brake tuning", amount: 99 },
  { item: "Spoke installation", amount: 99 },
  { item: "Gear tuning", amount: 99 },
  { item: "Wheel truing on cycle (per wheel)", amount: 99 },
  { item: "Bottom bracket service", amount: 149 },
  { item: "Headset service", amount: 149 },
  { item: "New headset installation", amount: 149 },
  { item: "Wheel hub service (per hub)", amount: 149 },
  { item: "Wheel truing on truing stand (per wheel)", amount: 149 },
  { item: "Hanger bend with gear tuning", amount: 149 },
  { item: "Bike degrease, wash and lube", amount: 149 },
  { item: "Wheel building / motor replacement", amount: 499 },
];

export const SPARE_PART_LABOUR = [
  { item: "Light and switch", amount: 49 },
  { item: "Display", amount: 99 },
  { item: "Throttle", amount: 99 },
  { item: "PAS (pedal-assist sensor)", amount: 99 },
  { item: "Harness replacement", amount: 149 },
  { item: "Controller (removable battery)", amount: 199 },
  { item: "Controller (non-removable battery)", amount: 299 },
  { item: "Controller and battery", amount: 499 },
];

export const SERVICE_PROMISES = [
  { title: "Genuine service", subtitle: "Best performance" },
  { title: "Expert technicians", subtitle: "Quality work" },
  { title: "Better care", subtitle: "Longer life" },
  { title: "Your ride", subtitle: "Our pride" },
];
